import { Dispatch, SetStateAction, createContext } from 'react'
import { TLivePrice } from './types'

export const SetLivePriceContext = createContext<Dispatch<
  SetStateAction<TLivePrice | null>
> | null>(null)

export const LivePriceContext = createContext<TLivePrice | null>(null)

export const SetLivePriceContextWithPath = createContext<Dispatch<
  SetStateAction<{ [x: string]: TLivePrice | null } | null>
> | null>(null)

export const LivePriceContextWithPath = createContext<{
  [x: string]: TLivePrice | null
} | null>(null)
